import { __decorate } from "tslib";
import { FrontendFeaturePlugin } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let MpfOptInUnlockVideoJumpingFrontendFeature = /*#__PURE__*/(() => {
  let MpfOptInUnlockVideoJumpingFrontendFeature = class MpfOptInUnlockVideoJumpingFrontendFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@mpf/optin-unlock-video-jumping/frontend-shared","featureId":"mpf-optin-unlock-video-jumping"};
    }
    getFeatureFunctionality(functionality) {}
    onFeatureInit() {
      console.log('allowSceneNavigation enabled');
      this.config.setOverride('courses.allowSceneNavigation', true);
    }
    onFeatureDestroy() {
      console.log('allowSceneNavigation disabled');
      this.config.clearOverride('courses.allowSceneNavigation');
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMpfOptInUnlockVideoJumpingFrontendFeature_BaseFactory;
        return function MpfOptInUnlockVideoJumpingFrontendFeature_Factory(__ngFactoryType__) {
          return (ɵMpfOptInUnlockVideoJumpingFrontendFeature_BaseFactory || (ɵMpfOptInUnlockVideoJumpingFrontendFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MpfOptInUnlockVideoJumpingFrontendFeature)))(__ngFactoryType__ || MpfOptInUnlockVideoJumpingFrontendFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MpfOptInUnlockVideoJumpingFrontendFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({});
    }
  };
  MpfOptInUnlockVideoJumpingFrontendFeature = __decorate([ClassName("MpfOptInUnlockVideoJumpingFrontendFeature")], MpfOptInUnlockVideoJumpingFrontendFeature);
  return MpfOptInUnlockVideoJumpingFrontendFeature;
})();
export { MpfOptInUnlockVideoJumpingFrontendFeature };